angular.module('manageSysManageHotWordsManageModule', [])
	.controller('manageSysManageHotWordsManageCtrl', ['$scope', function($scope){
		console.log("这里是热词管理")
	}]);